import {
  isValidPhoneNumber,
  parsePhoneNumberWithError,
} from 'libphonenumber-js';
import z from 'zod';

export const editParticipantEventSchema = z.object({
  usagesLeft: z.preprocess(
    (val) => {
      if (typeof val === 'string' && val.trim() !== '') {
        return Number(val);
      }
      if (typeof val === 'number') {
        return val;
      }
      return val;
    },
    z
      .number({
        required_error: 'Attempts left is required',
        invalid_type_error: 'Attempts left is required',
      })
      .min(0, 'Attempts left must be greater or equal to 0')
      .max(1000, 'Attempts left must be less than 1000')
  ),
  type: z.string().min(1, 'Type is required'),
});

function checkPhoneNumber(value: string) {
  if (!value) return true;

  try {
    const parsedNumber = parsePhoneNumberWithError(value);
    const countryCode = parsedNumber.country;

    return isValidPhoneNumber(value, countryCode);
  } catch {
    return false;
  }
}

const PhoneNumberScheme = z
  .string()
  .refine((val) => checkPhoneNumber(val), 'Phone number is not valid');

export const ParticipantTypeFormSchema = z.object({
  types: z.array(
    z.object({
      id: z.string().nullable().optional(),
      value: z
        .string()
        .min(1, 'Type is required')
        .max(50, 'Type name cannot exceed 50 characters'),
      phoneNumbers: z.array(z.object({ value: PhoneNumberScheme })),
    })
  ),
});
